<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết - {{ info.accountName }}</h1>
    </div>
    <!-- <b-breadcrumb :items="[
      {
        text: 'Home',
        href: '/'
      }, {
        text: 'Merchant owner',
        href: '#'
      }
    ]" /> -->

    <b-card>
      <!-- <template #header>
        <ul class="report-preview">
          <li>
            <div class="label">Liên hệ</div>
            <div class="value">{{ info && info.collapse && info.collapse.contacts || 0 }}</div>
          </li>
          <li>
            <div class="label">Thiết bị</div>
            <div class="value">{{ info && info.collapse && info.collapse.deviceStores || 0 }}</div>
          </li>
          <li>
            <div class="label">Nhân viên</div>
            <div class="value">{{ info && info.collapse && info.collapse.storeStaffs || 0 }}</div>
          </li>
        </ul>
      </template> -->

      <b-row class="gx-2">
        <b-col cols="2" md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.accountName"
            :moId="info.merchantOwnerId"
          ></MenuInner>
        </b-col>
        <b-col cols="10" md="5">
          <DetailInfo :info="info" :isLoading="isLoading" :fields="keyNames">
            <!-- <template #id="{ value }">
              <strong>{{ value }}</strong>
            </template> -->
            <template #businessRegistration>
              {{
                `${info.businessRegistrationAddress || ''} - ${getRegionName(info.provinceCode)} -
              ${getDistrictName(info.districtCode)}`
              }}
            </template>
            <template #headquarters>
              {{
                `${info.headquartersAddress || ''} - ${getRegionName(info.headquartersProvinceCode)} -
              ${getDistrictName(info.headquartersDistrictCode)}`
              }}
            </template>
            <template #mainBusinessMcc="{ value }">
              {{ getMccName(value) }}
            </template>
            <template #ownershipType="{ value }">
              {{ getOwnerTypeName(value) }}
            </template>
            <template #merchantLevel="{ value }">
              {{ getMcLvl(value) }}
            </template>
            <template #accountName="{ value }">
              <b-link :href="`/list-mc/${info.customerId}`" size="sm" target="_blank">
                {{ value || '' }}
              </b-link>
            </template>
          </DetailInfo>

          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Trạng thái</strong>
              <!-- <span class="float-right"><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span> -->
            </h1>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Hoạt động:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      <span v-if="info.status" :class="`badge ${getStatusClass(info.status)}`">
                        {{ getStatusName(info.status) }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin Mobile User</strong>
              <!-- <span class="float-right"><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span> -->
            </h1>
            <template v-if="!isLoading && info?.mobileUsers?.length > 0">
              <b-table
                hover
                sticky-header
                head-variant="light"
                responsive
                :items="info?.mobileUsers || []"
                :fields="fields"
                :fixed="true"
                :bordered="true"
                :busy.sync="isLoading"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #emptyfiltered="{ emptyFilteredText }">
                  <h4>{{ emptyFilteredText }}</h4>
                </template>
                <template #cell(vaMode)="{ item }">
                  {{
                    item.vaMode === 'VAMC'
                      ? 'VA trực tiếp'
                      : item.vaMode === 'VANP'
                        ? 'VA gián tiếp'
                        : item.vaMode
                  }}
                </template>
              </b-table>
            </template>
          </div>
        </b-col>
        <b-col cols="10" md="5">
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin người đại diện</strong>
              <!-- <span class="float-right"><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span> -->
            </h1>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Địa chỉ theo ĐKKD:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.businessRegistrationAddress }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Địa chỉ văn phòng:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.businessRegistrationAddress }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Số điện thoại:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.mobile }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Email:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.email }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <div class="d-flex">
              <h1>
                <strong class="h1-strong">Thông tin khác</strong>
              </h1>
              <b-button
                :disabled="!secondStaff.length || !hasRemovePerm"
                style="width: 60px"
                size="sm"
                variant="light"
                @click="openRemoveAoModal()"
                >Gỡ gán</b-button
              >
            </div>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Nguồn:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.referSource }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Vùng merchant:</p>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ getRegionName(info.provinceCode) }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <p class="float-left">Nhân viên phát triển:</p>
                  </label>
                  <div class="col-sm-8">
                    <div v-if="getMainStaff">
                      <span class="text-muted">Chính</span>:
                      <b-link :href="`/staff/detail/?id=${getMainStaff.staffId}`" target="_blank">
                        {{ getMainStaff.staffName }}
                      </b-link>
                    </div>

                    <div v-if="getSecondStaff">
                      <div>
                        <span class="text-muted">Phụ</span>:
                        <div
                          class="d-flex justify-content-between align-items-center mt-1"
                          v-for="(staff, index) in getSecondStaff"
                          :key="staff.id"
                        >
                          <a
                            style="cursor: pointer"
                            :href="`/staff/detail/?id=${staff.staffId}`"
                            target="_blank"
                          >
                            {{ `${staff.staffName}` }}
                          </a>
                          <!--                          <b-button-->
                          <!--                            style="margin-right: 30px"-->
                          <!--                            v-if="hasRemovePerm"-->
                          <!--                            variant="outline-danger"-->
                          <!--                            size="sm"-->
                          <!--                            @click="removeAO(staff)"-->
                          <!--                          >-->
                          <!--                            <b-icon icon="trash"></b-icon>-->
                          <!--                          </b-button>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <RemoveAoModal
      ref="AoModal"
      :second-staff="secondStaff"
      :level-assign="'MERCHANT_ACCOUNT'"
      @loadData="loadData"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Detail } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner'
  import { CommonService } from '@/services/common.service'
  import Config from '@/thirdParty/config'
  import { level2LocationDetails, level3LocationDetails } from '@/config/manhthdConfigs'
  import moment from 'moment'
  import { Remove } from '@/services/customer-support/assign_order'
  import RemoveAoModal from '@/pages/customer-support/cskh/account/components/RemoveAoModal.vue'
  export default {
    components: {
      RemoveAoModal,
      DetailInfo,
      MenuInner,
    },
    data() {
      return {
        isOpen: false,
        isLoading: false,
        isLoadingContract: false,
        id: '',
        info: {},
        fields: [
          {
            key: 'mobileUserName',
            label: 'Mobile User Name',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'vaMode',
            label: 'VA Mode',
            sortable: false,
          },
        ],
        keyNames: [
          { key: 'id', label: 'ID' },
          { key: 'accountName', label: 'Tên tài khoản' },
          // { key: 'taxCode', label: 'Mã số thuế' },
          { key: 'businessRegistrationNumber', label: 'Số giấy ĐKKD' },
          // { key: 'mobile', label: 'Số điện thoại' },
          // { key: 'email', label: 'Email' },
          // { key: 'website', label: 'Website' },
          { key: 'merchantLevel', label: 'Cấp bậc merchant' },
          { key: 'ownershipType', label: 'Loại hình sở hữu' },
          { key: 'mainBusinessMcc', label: 'Ngành nghề' },
          // { key: 'detailedBusinessMcc', label: 'Ngành nghề KD chi tiết' },
          // { key: 'businessRegistration', label: 'Địa chỉ ĐKKD' },
          // { key: 'businessRegistrationAddress', label: 'Địa chỉ theo ĐKKD' },
          // { key: 'headquartersAddress', label: 'Địa chỉ văn phòng hoạt động' },
          // { key: 'headquarters', label: 'Trụ sở chính' },
          // { key: 'logo', label: 'Logo thương hiệu' },
          // { key: 'mcStatus', label: 'Trạng thái hoạt động' },
          // { key: 'authStatus', label: 'Trạng thái xác thực' },
          // { key: 'syncStatus', label: 'Trạng thái cập nhật/ đồng bộ dữ liệu' },
          // { key: 'lastSyncAt', label: 'Thời gian cuối cập nhật/ đồng bộ dữ liệu' },
          // { key: 'refCustomerId', label: 'Nguồn lấy từ MPOS/MY_NEXTPAY' },
          // { key: 'urlBusResgistrationNumber', label: 'Link ảnh ĐK KD' },
          // { key: 'regionCode', label: 'Mã vùng kinh doanh' },
          // { key: 'saleStaffId', label: 'Mã nhân viên' }
        ],
        dataConfigService: [],
        dataConfigRegion: [],
        dataConfigMcc: [],
        ownershipType: [],
        listState: Config.listStatusMC,
        listAuthStatus: [
          { id: 'NOT_AUTHENTICATED', text: 'Chưa xác thực' },
          { id: 'AUTHENTICATED', text: 'Đã xác thực' },
        ],
        AuthStatusClass: {
          NOT_AUTHENTICATED: 'badge-warning',
          AUTHENTICATED: 'badge-success',
        },
        listStatus: [
          { id: 'ACTIVE', text: 'Đang hoạt động', bgColor: 'badge-primary' },
          { id: 'DENIED', text: 'Bị từ chối', bgColor: 'danger' },
          {
            id: 'PENDING_CONFIRM_APPROVAL',
            text: 'Chờ Bank thẩm định',
            bgColor: 'badge-info',
          },
          {
            id: 'PENDING_APPROVAL',
            text: 'Chờ MPOS thẩm định',
            bgColor: 'badge-warning',
          },
          {
            id: 'PENDING_INFORMATION',
            text: 'Chưa thiết lập thông tin',
            bgColor: 'badge-info',
          },
          { id: 'SUSPENDED', text: 'Đang khóa', bgColor: 'badge-danger' },
          { id: 'UNDEFINED', text: 'Không xác định', bgColor: 'badge-secondary' },
        ],
        DetailMenus: [
          {
            id: 'thong_tin_chung',
            label: 'Thông tin chung',
            icon: 'person-lines-fill',
            link: '/customer-support/account/{id}',
          },
          {
            id: 'lich_su_gan',
            label: 'Lịch sử gán NV',
            icon: 'list-check',
            link: '/customer-support/account/{id}/history-assign',
          },
          {
            id: 'lich_su_go_gan',
            label: 'Lịch sử gỡ gán NV',
            icon: 'list-check',
            link: '/customer-support/account/{id}/history-remove-assign',
          },
          {
            id: 'list_store',
            label: 'Danh sách cửa hàng',
            icon: 'shop',
            link: '/customer-support/store/?maId={maId}&maName={maName}',
          },
          {
            id: 'list_task',
            label: 'Danh sách công việc',
            icon: 'list-task',
            link: '/customer-support/task/?maId={maId}&maName={maName}',
          },
          {
            id: 'list_task_processed',
            label: 'Thông báo chiến dịch',
            icon: 'list-task',
            link: '/customer-support/task-type-purpose?maId={maId}&maName={maName}',
          },
          {
            id: 'list_contact',
            label: 'Danh sách liên hệ',
            icon: 'phone',
            link: '/customer-support/contact/?maId={maId}&maName={maName}',
          },
          {
            id: 'list_device',
            label: 'Trạng thái sử dụng thiết bị',
            icon: 'list-check',
            link: '/customer-support/device-store/?maId={maId}&maName={maName}',
          },
        ],
        activeItem: 'thong_tin_chung',
        listMcType: [
          {
            id: 'MC_KEY',
            text: 'Merchant key',
          },
          {
            id: 'MC_NORMAL',
            text: 'Merchant thường',
          },
        ],
        list: [
          {
            mcAccId: 'ABCD1234',
            mcAccName: 'Nguyễn Văn A',
            storeName: 'Shop 1',
            address: '18 Tam Trinh',
          },
        ],
        secondStaff: [],
      }
    },

    filters: {},

    async created() {
      this.id = this.$router.currentRoute.params.id
      await this.configSystem()
    },

    mounted() {
      if (this.dataPermission.includes('CNPS_CSS_MA_DETAIL')) {
        this.toggleSideBar()
        this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },

      getMcLvl() {
        return mcLvl => {
          const objLvl = this.listMcType.find(s => s.id === mcLvl)
          return objLvl ? objLvl.text : mcLvl
        }
      },

      getRegionName() {
        return code => {
          const objRegion = level2LocationDetails.find(lvl => lvl.code === code)
          return objRegion ? objRegion.name : code
        }
      },
      getDistrictName() {
        return code => {
          const objDistrict = level3LocationDetails.find(lvl => lvl.code === code)
          return objDistrict ? objDistrict.name : code
        }
      },
      getMccName() {
        return code => {
          const objMcc = this.dataConfigMcc.find(Mcc => Mcc.id === code)
          return objMcc ? objMcc.text : code
        }
      },
      getOwnerTypeName() {
        return code => {
          const objownerType = this.ownershipType.find(ownerType => ownerType.id === code)
          return objownerType ? objownerType.text : code
        }
      },
      getMainStaff() {
        return this.info.staffAssigns && this.info.staffAssigns.length > 0
          ? this.info.staffAssigns.find(uInfo => uInfo.configType === 'MAIN')
          : undefined
      },
      getSecondStaff() {
        const usersInfo =
          this.info.staffAssigns && this.info.staffAssigns.length > 0
            ? this.info.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
            : []
        this.propSecondStaff(usersInfo)
        return usersInfo
        // return usersInfo.reduce((arr, userInfo) => {
        //   arr.push(`<a style="cursor: pointer;" href='/staff/detail/?id=${userInfo.staffId}' target="_blank">${userInfo.staffName}</a>`)
        //   return arr;
        // }, []);
      },
      hasRemovePerm() {
        return this.dataPermission.includes('CNPS_CSS_STAFF_ASSIGN_REMOVE')
      },
    },

    methods: {
      propSecondStaff(staff) {
        this.secondStaff = staff
      },
      openRemoveAoModal() {
        this.$refs.AoModal.show()
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      removeAO(staff) {
        const modal = this.approveMx(
          `Bạn có chắc chắn muốn gỡ nhân viên chăm sóc ${staff.staffName} ?`
        )
        modal.then(async close => {
          if (close) {
            await this.handleRemoveAO(staff)
          }
        })
      },
      async handleRemoveAO(staff) {
        try {
          const res = await Remove({
            levelAssign: 'MERCHANT_ACCOUNT',
            assignmentId: this.id,
            staffId: staff.staffId,
            configType: staff.configType,
          })
          if (res.result) {
            await this.loadData()
            this.showToastSuccess('Gỡ nhân viên chăm sóc thành công')
          }
        } catch (e) {
          console.log(e)
          this.showToastError(e.message)
        }
      },
      formatDate(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
      formatHour(date) {
        if (!date) return
        return moment(date).format('HH:mm')
      },
      setActive(id) {
        this.activeItem = id
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.ownershipType = data.data.ownershipType.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
              this.ownershipType.unshift({ id: 0, text: 'Tất cả' })
              this.dataConfigService = data.data.services.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigService.unshift({ id: 0, text: 'Tất cả' })
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigMcc.unshift({ id: 0, text: 'Tất cả' })
            }
          })
          .catch(error => console.error(error))
      },
    },
  }
</script>

<style scoped>
  .breadcrumb {
    margin-bottom: 0;
  }

  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul.report-preview {
    padding-left: 0;
    display: flex;

    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }

      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }

      & + li {
        margin-left: 10px;
      }
    }
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f;
    padding-left: 5px;
    font-size: larger;
  }

  .img_logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }

  .inner_menu {
    border-right: 1px solid #edf1fa;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }
  :deep(.b-table-sticky-header) {
    min-height: 120px !important;
  }
</style>
